import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { NotificationManager } from 'react-notifications';
import TextInput from './TextInput';
import ReactRTE from './ReactRTE';
import DropDown from './DropDown';
import { domains } from '../configs/domains';
import ProductService from '../Services/ProductService';
import Button from './Button';
import StringUtils from '../Utils/StringUtils';
export default function EditProduct({ existingValues }) {
	const [enable, setEnable] = useState(true);
	let initialValues = {
		...existingValues,
		tags: existingValues.tags ? StringUtils.arrayToTags(existingValues.tags) : null
	};
	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit: (values) => {
			console.log('submitting');
			console.log(values);
			values = { ...values, tags: values.tags ? StringUtils.tagsToArray(values.tags) : null };
			ProductService.updateProduct({ ...existingValues, ...values })
				.then((response) => {
					console.log(response);
					NotificationManager.success(`Updated ${values.amazon_key}`);
					setEnable(true);
				})
				.catch((e) => {
					console.log(e);
					NotificationManager.error(`Error Updating ${values.amazon_key}`);
					setEnable(true);
				});
		}
	});

	return (
		<Fragment>
			<form>
				<TextInput
					label="Key"
					placeholder="Key"
					name="key"
					onChange={formik.handleChange}
					value={formik.values.amazon_key}
					disabled={true}
					error={formik.errors.amazon_key}
					message={'You need a manager approval to change Slug'}
				/>
				<DropDown
					onChange={(data) => {
						console.log(data);
						formik.setFieldValue('domain', data.value);
					}}
					value={formik.values.domain}
					name="domain"
					options={domains}
					label="Select domain"
					error={formik.errors.domain}
					disabled={true}
				/>
				<TextInput
					label="Slug"
					placeholder="Slug"
					name="slug"
					onChange={formik.handleChange}
					value={formik.values.slug}
					disabled={true}
					error={formik.errors.slug}
					message={'You need a manager approval to change Slug'}
				/>
				<TextInput
					label="Brand"
					placeholder="brand"
					name="brand"
					onChange={formik.handleChange}
					value={formik.values.brand}
					disabled={!enable}
					error={formik.errors.brand}
				/>
				<TextInput
					label="Tags (tags are comma seperated, Ex: kayak, paddle, canoe) (one tag can have no commas: kayak)"
					placeholder="Tags"
					name="tags"
					onChange={formik.handleChange}
					value={formik.values.tags}
					disabled={!enable}
					error={formik.errors.tags}
					gpt={"PRODUCT_TAGS"}
					setFieldValue={formik.setFieldValue}
					gptOthers={formik.values.featuredBullets}
				/>
				<TextInput
					label="Title"
					placeholder="Title"
					name="title"
					onChange={formik.handleChange}
					value={formik.values.title}
					disabled={!enable}
					error={formik.errors.title}
					setFieldValue={formik.setFieldValue}
					gpt={"PRODUCT_TITLE"}
				/>
				<TextInput
					label="Affiliate Link"
					placeholder="Affiliate Link"
					name="affiliateLink"
					onChange={formik.handleChange}
					value={formik.values.affiliateLink}
					disabled={!enable}
					error={formik.errors.affiliateLink}
				/>
				<TextInput
					label="SEO Title"
					placeholder="SEO Title (Max 60 characters)"
					name="seoTitle"
					onChange={formik.handleChange}
					value={formik.values.seoTitle}
					disabled={!enable}
					error={formik.errors.seoTitle}
					gpt={"PRODUCT_SEO_TITLE"}
					setFieldValue={formik.setFieldValue}
					gptOthers={formik.values.title}

				/>
				<TextInput
					label="SEO Description (Max 160 characters)"
					placeholder="SEO Description (Max 160 characters)"
					name="seoDescription"
					onChange={formik.handleChange}
					value={formik.values.seoDescription}
					disabled={!enable}
					error={formik.errors.seoDescription}
					gpt={"PRODUCT_SEO_DESCRIPTION"}
					setFieldValue={formik.setFieldValue}
					gptOthers={formik.values.title}
				/>

				<TextInput
					label="Image (Image URL ex:https://www.mywebsite.com/image.png)"
					placeholder="Image url"
					name="image"
					onChange={formik.handleChange}
					value={formik.values.image}
					disabled={!enable}
					error={formik.errors.image}
				/>
				<label className="w-full form-label font-bold inline-block mt-2 text-gray-700">Featured Bullets</label>
				<ReactRTE
					value={formik.values.featuredBullets}
					setValue={formik.setFieldValue}
					name="featuredBullets"
					id="featuredBullets"
					gpt={"PRODUCT_FEATURED_BULLETS"}
				/>

				<label className="w-full form-label font-bold inline-block mt-2 text-gray-700">Pros</label>
				<ReactRTE
					value={formik.values.pros}
					setValue={formik.setFieldValue}
					name="pros"
					id="pros"
					gpt={"PRODUCT_PROS"}
					gptOthers={formik.values.featuredBullets}
				/>

				<label className="w-full form-label font-bold inline-block mt-2 text-gray-700">Cons</label>
				<ReactRTE
					value={formik.values.cons}
					setValue={formik.setFieldValue}
					name="cons"
					id="cons"
					gpt={"PRODUCT_CONS"}
					gptOthers={formik.values.featuredBullets}
				/>
				{/* <label className="w-full form-label font-bold inline-block mt-2 text-gray-700">Description</label>
				<ReactRTE
					value={formik.values.description}
					setValue={formik.setFieldValue}
					name="description"
					id="description"
				/> */}
				<Button text="Submit" disabled={!enable} type="submit" onClick={formik.handleSubmit} />
			</form>
		</Fragment>
	);
}

const validationSchema = Yup.object().shape({
	domain: Yup.string().required('Required'),
	seoTitle: Yup.string()
		.min(3, 'Too Short! It should be more than 3')
		.max(61, 'Too Long! It should be less than 60')
		.nullable(),
	brand: Yup.string()
		.min(1, 'Too Short! It should be more than 3')
		.max(160, 'Too Long! It should be less than 160')
		.nullable(),
	tags: Yup.string()
		.min(1, 'Too Short! It should be more than 3')
		.max(400, 'Too Long! It should be less than 400')
		.nullable(),
	seoDescription: Yup.string()
		.min(3, 'Too Short! It should be more than 3')
		.max(160, 'Too Long! It should be less than 160')
		.nullable(),
	slug: Yup.string()
		.min(3, 'Too Short! It should be more than 3')
		.max(160, 'Too Long! It should be less than 160')
		.matches(/^[a-zA-Z0-9_.-]+$/, 'Characters, numbers and dashes only. So white spaces!')
		.required('Required'),
	title: Yup.string()
		.min(3, 'Too Short! It should be more than 3')
		.max(61, 'Too Long! It should be less than 60')
		.required('Required'),
	image: Yup.string().url().required('Required'),
	affiliateLink: Yup.string().url(),
	featuredBullets: Yup.string().min(3, 'Too Short! It should be more than 3').required('Required'),
	pros: Yup.string().min(3, 'Too Short! It should be more than 3').nullable('Required'),
	cons: Yup.string().min(3, 'Too Short! It should be more than 3').nullable('Required')
	// description: Yup.string().min(3, 'Too Short! It should be more than 3').required('Required')
});
